import { Container } from './container';
import { registerGlobalExecutor } from './hox-root';
import { useDataFromContainer } from './use-data-from-container';
import { memo, useEffect, useState } from 'react';
export function createGlobalStore(hook) {
    let container = null;
    function getContainer() {
        if (!container) {
            throw new Error('Failed to retrieve data from global container. Please make sure you have rendered HoxRoot.');
        }
        return container;
    }
    const GlobalStoreExecutor = memo(() => {
        const [innerContainer] = useState(() => new Container(hook));
        container = innerContainer;
        innerContainer.data = hook();
        useEffect(() => {
            innerContainer.notify();
        });
        return null;
    });
    registerGlobalExecutor(GlobalStoreExecutor);
    function useGlobalStore(depsFn) {
        return useDataFromContainer(getContainer(), depsFn);
    }
    function getGlobalStore() {
        return getContainer().data;
    }
    return [useGlobalStore, getGlobalStore];
}
